// extracted by mini-css-extract-plugin
module.exports = {"container":"AffliateTransactions_container__2BsPj","wrapper":"AffliateTransactions_wrapper__3IY-k","name_field":"AffliateTransactions_name_field__1Oh5w"};